import axios from '@/libs/api.request'

/** 批量生成堂食桌码（PNG 保存到服务端 static/shop-dine-qrcodes） */
export const shopDineBatchQrcodes = (data) => {
  return axios.request({
    url: 'shop-dine/admin/qrcodes/batch',
    method: 'post',
    data,
  })
}

/** 已生成的桌码文件列表 */
export const shopDineQrcodeList = () => {
  return axios.request({
    url: 'shop-dine/admin/qrcodes/list',
    method: 'get',
  })
}
